// Number formatting utilities
export const formatNumber = (num) => Number(num).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export const formatCurrency = (num) => `£${formatNumber(num)}`;

export const formatPercentage = (num) => `${formatNumber(num)}%`;
